<template>
  <iframe :src="src" style="height: 100%; width: 100%"></iframe>
</template>
<script>
import urlTemplate from "@/shared/url-template";
import api from "@/api/visary-api";
import repository from "@/api/visary-api/repository";
import resources from "@/api/visary-api/resources";
import { authService } from "@rosgidromet/visary-identity-vue-rgm";

export default {
  name: "vis-hangfire-dashboard",
  data() {
    return {
      src: null,
    };
  },
  async created() {
    await api.user.getCurrent();
    const token = await authService.getAccessToken();

    this.src = repository.instance.defaults.baseURL + `/${urlTemplate(resources.admin.hangfire, {
        access_token: token,
      })}`;
  }
};
</script>
